import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Alert from "@material-ui/lab/Alert";
import Grid from "@material-ui/core/Grid";
import Switch from "@material-ui/core/Switch";
import { invokeApi } from "../../../../bl_libs/ApiCalling";
import { withRouter } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: "#c4314b",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  txt: {
    color: "black",
  },
  alert: {
    width: "100%",
  },
  swtch: {
    marginTop: "20px",
  },
}));

function ServiceForm(props) {
  const classes = useStyles();
  const [zipcode, setzipcode] = useState();
  const [latitude, setlatitude] = useState("");
  const [longitude, setlongitude] = useState("");
  const [isactive, setisactive] = React.useState(true);
  const [errorflag, setflag] = useState("");
  const [iswaiting, setiswaiting] = useState(false);

  const handlesubmit = (event) => {
    event.preventDefault();
    addservicearea();
  };
  const addservicearea = () => {
    let Data = {
      zip_code: zipcode,
      latitude: latitude,
      latitude: latitude,
      longitude: longitude,
      is_active: isactive ? "0" : "1",
    };
    const token = localStorage.getItem("token");
    let requestObj = {
      path: "/api/admin/add_zip_code",
      method: "POST",
      postData: Data,
      headers: {
        "x-sh-auth": token,
      },
    };
    invokeApi(requestObj).then((res) => {
      //console.log(res, "RESPONSE");
      if (res.code == 200) {
        setiswaiting(false);
        props.history.push("/admin/service-area");
      } else {
        setiswaiting(false);
        setflag(res.message);
      }
    });
  };
  const handleback = () => {
    props.history.push({ pathname: props.history.location.state.route });
  };
  const handleZipCode = (event) => {
    setzipcode(event.target.value);
  };
  const handleLatitude = (event) => {
    setlatitude(event.target.value);
  };
  const handleLongitude = (event) => {
    setlongitude(event.target.value);
  };
  const handleisactivechanged = (event) => {
    setisactive((c) => !c);
  };
  if (iswaiting) {
    return (
      <div className="Circular-Progress">
        <CircularProgress color="primary" />
      </div>
    );
  }
  return (
    <>
      <Container component="main" maxWidth="sm">
        <ArrowBackIcon
          className="backarrow pointer-point"
          color="primary"
          onClick={handleback}
        ></ArrowBackIcon>
        <CssBaseline />
        <div className={classes.paper}>
          <Typography className={classes.txt} component="h1" variant="h5">
            Add Service Area
          </Typography>
          {errorflag && (
            <Alert className={classes.alert} severity="error">
              {errorflag}
            </Alert>
          )}
          <form className={classes.form} onSubmit={handlesubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  id="zipcode"
                  onChange={handleZipCode}
                  label="zip code"
                  name="zip code"
                  autoFocus
                />
              </Grid>
            </Grid>
            Status:
            <Switch
              checked={isactive}
              onChange={handleisactivechanged}
              color="primary"
              name="status"
              inputProps={{ "aria-label": "primary checkbox" }}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
            >
              Add Service
            </Button>
          </form>
        </div>
      </Container>
    </>
  );
}
export default withRouter(ServiceForm);
